import styles from "./styles/stats-count.module.scss";

const StatsCount = () => {
  const data = [
    {
      title: "Conversions",
      value: "25,745,984",
    },
    {
      title: "Voices Trained",
      value: "1,576,565",
    },
  ];
  return (
    <div className={styles.wrapper}>
      {data.map((item, index) => (
        <>
          <div className={styles.stats}>
            <div className={styles.value}>{item.value}</div>
            <div className={styles.title}>{item.title}</div>
          </div>
          {index !== data.length - 1 && (
            <div className={styles.separator}></div>
          )}
        </>
      ))}
    </div>
  );
};

export default StatsCount;
